import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__logout-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { onOnsuccess: _ctx.deleteItem }, {
    title: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.Ti18N("account.modalWords.clearWords")), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.Ti18N("account.modalWords.warning")), 1)
    ]),
    acceptButton: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.Ti18N("logout")), 1)
    ]),
    _: 1
  }, 8, ["onOnsuccess"]))
}